<section class="row mb-4 pl-2 border-left">
  <section class="col-sm-12 col-md-12 mb-4 mt-4">
    <h2 class="h6 font-weight-bold mb-2">Registra parafiscal</h2>
    <div class="row">
      <div class="col-sm-12 col-md-4 mt-1">
        <label class="small text-muted mb-0">Ingresos anuales<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.total_ventas}}</strong></label>
      </div>
      <div class="col-sm-12 col-md-4 mt-1">
        <label class="small text-muted mb-0">Se encuentra obligado a realizar aportes parafiscales<br>
          <strong class="h6 text-dark font-weight-bold" *ngIf="informacionEstablecimiento.supera_pago_parafiscales">SI</strong>
          <strong class="h6 text-dark font-weight-bold" *ngIf="!informacionEstablecimiento.supera_pago_parafiscales">NO</strong>
        </label>
      </div>
    </div>
  </section>
</section>